import * as React from "react";

const noop = () => undefined;

export function useScrolledPast(threshold: number, enabled = true) {
  return React.useSyncExternalStore(
    (onChange) => {
      if (!enabled) return noop;
      window.addEventListener("scroll", onChange, { passive: true });
      return () => window.removeEventListener("scroll", onChange);
    },
    () => enabled && window.scrollY > threshold,
    () => false
  );
}
